<!-- 講座概要ページ -->
<script setup lang="ts">
  import { usePlanStore } from "~/stores/PlanStore";
  import { usePlanTabStore } from "~/stores/PlanTabStore";
  import PlanTabMenuConfig from "~/consts/PlanTabMenuConfig";
  import { useMetaTags } from "~/composables/useMetaTags";

  const planId = useRoute().params.id as string;
  const content = () => String(useRoute().query.content || "live");

  const planStore = usePlanStore();
  planStore.resetPlan(planId);
  planStore.fetchOne(planId);

  const planTabStore = usePlanTabStore();

  // meta/ogp
  const headTitle = ref();
  const headDescription = ref();
  const ogpUrl = ref();
  const ogpImage = ref();
  const noIndex = ref<boolean | null>(null);
  const setMeta = () => {
    if (planStore.plan) {
      headTitle.value = planStore.plan.title + ` | Fincs`;
      headDescription.value = planStore.plan.description;
      ogpUrl.value = `https://fincs.jp/plan/${planStore.plan.id}/`;
      ogpImage.value = planStore.plan.thumbnailImage;
      noIndex.value = planStore.plan.isPrivate;

      switch (planTabStore.getTab()) {
        case PlanTabMenuConfig.TALK.value:
          headTitle.value = `${planStore.plan.title}の${PlanTabMenuConfig.TALK.title}一覧 | Fincs`;
          ogpUrl.value = `https://fincs.jp/plan/${planStore.plan.id}/?tab=talk`;
          break;
        case PlanTabMenuConfig.CONTENT.value:
          if (content() === "live") {
            headTitle.value = `${planStore.plan.title}の${PlanTabMenuConfig.LIVE.title}一覧 | Fincs`;
            ogpUrl.value = `https://fincs.jp/plan/${planStore.plan.id}/?tab=content&content=live`;
          } else if (content() === "movie") {
            headTitle.value = `${planStore.plan.title}の${PlanTabMenuConfig.MOVIE.title}一覧 | Fincs`;
            ogpUrl.value = `https://fincs.jp/plan/${planStore.plan.id}/?tab=content&content=movie`;
          } else if (content() === "document") {
            headTitle.value = `${planStore.plan.title}の${PlanTabMenuConfig.DOCUMENT.title}一覧 | Fincs`;
            ogpUrl.value = `https://fincs.jp/plan/${planStore.plan.id}/?tab=content&content=document`;
          } else {
            headTitle.value = `${planStore.plan.title}の${PlanTabMenuConfig.LIBRARY.title}一覧 | Fincs`;
            ogpUrl.value = `https://fincs.jp/plan/${planStore.plan.id}/?tab=content&content=${content}`;
          }
          break;
        case PlanTabMenuConfig.MEMBER_LIST.value:
          headTitle.value = `${planStore.plan.title}の${PlanTabMenuConfig.MEMBER_LIST.title}一覧 | Fincs`;
          ogpUrl.value = `https://fincs.jp/plan/${planStore.plan.id}/?tab=member_list`;
          break;
      }
    }
  };

  watch(
    () => {
      return planTabStore.getTab();
    },
    () => {
      setMeta();
    },
    { immediate: true },
  );

  watch(
    () => {
      return planStore.plan;
    },
    () => {
      setMeta();
    },
    { immediate: true },
  );

  watch(
    () => {
      return content();
    },
    () => {
      setMeta();
    },
    { immediate: true },
  );

  const metaTags = useMetaTags({
    headTitle,
    headDescription,
    ogpUrl,
    ogpImage,
    noIndex,
  });
  useHead({
    title: headTitle,
    meta: metaTags,
  });
</script>

<template>
  <div>
    <NuxtLayout>
      <OrganismsMainLayout>
        <OrganismsPlanView :plan-info="planStore.plan" />
      </OrganismsMainLayout>
    </NuxtLayout>
  </div>
</template>
